/**
 * `node:child_process` — the browser runs no processes.
 *
 * The one process the demo answers is `git show <sha>:<path>`, which `sibyl recheck` uses to recover
 * the quote a stored record does not keep; it is answered from the sample trees. Anything else fails
 * exactly as a missing binary does (ENOENT), which every caller in sibyl already handles.
 */
type Cb = (err: Error | null, stdout: string, stderr: string) => void
let gitShow: (spec: string) => string | undefined = () => undefined
export function setGitShow(fn: (spec: string) => string | undefined): void {
  gitShow = fn
}
export function execFile(bin: string, args: readonly string[], opts: unknown, cb?: Cb): void {
  const done = typeof opts === "function" ? (opts as Cb) : cb
  if (bin === "git" && args.includes("show")) {
    const spec = args[args.indexOf("show") + 1] ?? ""
    const text = gitShow(spec)
    queueMicrotask(() =>
      text === undefined
        ? done?.(Object.assign(new Error(`fatal: invalid object name '${spec}'`), { code: 128 }), "", `fatal: invalid object name '${spec}'\n`)
        : done?.(null, text, ""),
    )
    return
  }
  const e = Object.assign(new Error(`spawn ${bin} ENOENT`), { code: "ENOENT" })
  queueMicrotask(() => done?.(e, "", ""))
}
export function execFileSync(bin: string): never {
  throw Object.assign(new Error(`spawn ${bin} ENOENT`), { code: "ENOENT" })
}
export default { execFile, execFileSync }
